import { render, staticRenderFns } from "./AccountActivation.vue?vue&type=template&id=000f1ba8&scoped=true&"
import script from "./AccountActivation.vue?vue&type=script&lang=ts&"
export * from "./AccountActivation.vue?vue&type=script&lang=ts&"
import style0 from "./AccountActivation.vue?vue&type=style&index=0&id=000f1ba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000f1ba8",
  null
  
)

export default component.exports